import { render } from "./switch-user-modal.vue?vue&type=template&id=16ae4cc0"
import script from "./switch-user-modal.vue?vue&type=script&lang=ts"
export * from "./switch-user-modal.vue?vue&type=script&lang=ts"
script.render = render

export default script